export type DebugGroup = 'connection-efficiency' | 'codex-steering';

export type DebugEntry = {
  group: DebugGroup;
  time: string;
  event: string;
  payload: unknown;
  text: string;
};

export const DEBUG_GROUP_ORDER: DebugGroup[] = ['connection-efficiency', 'codex-steering'];

export const DEBUG_GROUP_LABELS: Record<DebugGroup, string> = {
  'connection-efficiency': '连接效率',
  'codex-steering': 'Codex 追加与气泡',
};

export function createDebugEntry(group: DebugGroup, event: string, payload: unknown = {}): DebugEntry {
  const safeGroup = group || 'connection-efficiency';
  const time = new Date().toISOString();
  return {
    group: safeGroup,
    time,
    event,
    payload,
    text: `[${safeGroup}] ${time} ${event} ${stringifyDebugPayload(payload)}`,
  };
}

export function stringifyDebugPayload(payload: unknown): string {
  try {
    return JSON.stringify(payload ?? {});
  } catch {
    return String(payload ?? '');
  }
}

export function appendDebugEntry(entries: DebugEntry[], entry: DebugEntry, maxEntries: number): void {
  entries.push(entry);
  const group = entry.group || 'connection-efficiency';
  let groupCount = 0;
  for (let index = entries.length - 1; index >= 0; index -= 1) {
    if (entries[index].group !== group) continue;
    groupCount += 1;
    if (groupCount > maxEntries) {
      entries.splice(index, 1);
    }
  }
}

export function getOrderedDebugGroups(entries: DebugEntry[]): DebugGroup[] {
  const seen = new Set(entries.map((entry) => entry.group || 'connection-efficiency'));
  const ordered = DEBUG_GROUP_ORDER.slice();
  for (const group of seen) {
    if (!ordered.includes(group)) ordered.push(group);
  }
  return ordered;
}

export function getDebugEntriesForGroup(entries: DebugEntry[], group: DebugGroup): DebugEntry[] {
  return entries.filter((entry) => (entry.group || 'connection-efficiency') === group);
}

export function getDefaultDebugGroup(entries: DebugEntry[], preferred: DebugGroup = 'connection-efficiency'): DebugGroup {
  if (getDebugEntriesForGroup(entries, preferred).length > 0) return preferred;
  if (getDebugEntriesForGroup(entries, 'connection-efficiency').length > 0) return 'connection-efficiency';
  if (getDebugEntriesForGroup(entries, 'codex-steering').length > 0) return 'codex-steering';
  return preferred;
}

export function getDebugEntryCount(entries: DebugEntry[], group?: DebugGroup): number {
  return group ? getDebugEntriesForGroup(entries, group).length : entries.length;
}

export function clearDebugEntriesForGroup(entries: DebugEntry[], group: DebugGroup): void {
  for (let index = entries.length - 1; index >= 0; index -= 1) {
    if ((entries[index].group || 'connection-efficiency') === group) entries.splice(index, 1);
  }
}
